import './style.css';
import { GameApp } from './ui/app';
import { Campfire } from './ui/campfire';

const app = document.querySelector<HTMLDivElement>('#app');
if (!app) throw new Error('#app mount point missing');

const canvas = document.createElement('canvas');
canvas.id = 'campfire-bg';
document.body.prepend(canvas);

const campfire = new Campfire(canvas);
campfire.start();

new GameApp(app, campfire).start();
